import type { OnboardingStepKey } from './api'

/** As etapas da implantação, na ordem da tela (RN-ADM-81). */
export const ONBOARDING_STEPS: OnboardingStepKey[] = [
  'clinic_profile',
  'witnesses',
  'procedures',
  'review',
]

export type StepState = 'done' | 'pending' | 'unknown'

/**
 * O estado de cada etapa a partir do resumo que o painel root recebe (RN-ADM-85): a atual é a
 * primeira que falta, então as anteriores estão feitas. Das seguintes só se sabe quantas estão
 * feitas, não quais; quando a conta não fecha, o estado fica desconhecido em vez de inventado.
 */
export function stepStatesFromSummary(summary: {
  isCompleted: boolean
  doneStepCount: number
  currentStep: OnboardingStepKey | null
}): { key: OnboardingStepKey; state: StepState }[] {
  const current = summary.currentStep
    ? ONBOARDING_STEPS.indexOf(summary.currentStep)
    : ONBOARDING_STEPS.length
  // A revisão só fica feita quando a implantação é concluída.
  const open = ONBOARDING_STEPS.filter((key, index) => index > current && key !== 'review')
  const doneAfterCurrent = summary.doneStepCount - current
  return ONBOARDING_STEPS.map((key, index) => {
    if (summary.isCompleted || index < current) return { key, state: 'done' }
    if (index === current || key === 'review' || doneAfterCurrent <= 0) {
      return { key, state: 'pending' }
    }
    return { key, state: doneAfterCurrent >= open.length ? 'done' : 'unknown' }
  })
}
